// extracted by mini-css-extract-plugin
export default {"banner":"PendingKycBanner_banner__4V27f","text":"PendingKycBanner_text__muDRY","cta":"PendingKycBanner_cta__6O+fj"};